export const siteSettings = {
  name: "Trade Nexus Exchange",
  link: "https://tradenexusex.live",
  email: "support@tradenexusex.live",
  appLink: "https://app.tradenexusex.live",
};
